import React, { useEffect, useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import LoadinSpin from '../../ui/LoadinSpin';
import { useGetDta } from '../../../hooks/useGetDta';
import RegPago from '../../../pages/finanzas/RegPago';

const ModAddPayUs = ({ show, onClose, callBk, activeTab, activo }) => {
    const { id: ids } = useParams();
    let idR = atob(ids);
    const [pago, setPago] = useState([]);
    const { loading, data, getInfo } = useGetDta(`factura/getpay/${idR}`);
    useEffect(() => {
        setPago(data);
    }, [data]);
    useEffect(() => {
        getInfo(`factura/getpay/${idR}`, {}, 'GET');
    }, [show, idR, activeTab, activo]);
    const onClear = () => {
        callBk();
        getInfo(`factura/getpay/${idR}`, {}, 'GET');
        onClose();
    };
    if (loading) return <LoadinSpin />;

    return (
        <Modal show={show} onHide={onClose} size="xl">
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Registrar pago </h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>{show && <RegPago data={pago} show={show} onClear={onClear} />}</Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};
export default ModAddPayUs;
